<template lang='pug' src='./accessibility.pug'></template>

<script>
import api from 'api'
import axios from 'axios'
import Loader from 'components/loader/loader'
import HeroSlider from 'components/custom/custom-hero-slider/custom-hero-slider'
import FooterMain from 'components/footer/footer'

export default {
  name: 'Accessibility',
  data: () => {
    return {
      name: 'thank-you',
      props: {},
      message: 'Thank You',
      videosource: [],
      loading: true,
      companyName: 'OPSmiles Orthodontics', // Fill this in
      domain: "<a href='https://www.opsmiles.com'>opsmiles.com</a>", // Fill this in
      email: "<a href='mailto:ortho@opsmiles.com'>ortho@opsmiles.com</a>, <a href='mailto:pedo@opsmiles.com'>pedo@opsmiles.com</a>", // Fill this in
      phone: "<a href='tel:18282640110'>828-264-0110</a>, <a href='tel:13366674114'>336-667-4114</a>", // Fill this in
      formattedEmail: ''
    }
  },
  created () {
    this.loading = true
    axios.get(api + '/acf/v3/pages/948 ')
      .then(response => {
        this.props = response.data.acf
        this.loading = false
        this.videosource.push(response.data.acf.promo_video_mp4)
        this.videosource.push(response.data.acf.promo_video_webm)
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors.push(e))
        console.log(e)
      })
  },
  components: {
    Loader,
    HeroSlider,
    FooterMain
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?4cad41d6